import Login from "./Pages/Login";
import "./Assets/css/App.css";
import "./Assets/css/dataTable.css";
import "./Assets/css/datePicker.css";
import { RouterProvider } from "react-router-dom";
// import router from "./Router/router";
import { PrimeReactProvider } from "primereact/api";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { useContext } from "react";
import RouterContext from "./Router/routerContext";
import NotificationProvider from "./App/Providers/NotificationProvider";

// import "primereact/resources/themes/md-light-indigo/theme.css";
// import "primereact/resources/themes/md-dark-indigo/theme.css";

const queryClient = new QueryClient();

function App() {
  const { router } = useContext(RouterContext);

  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
      <PrimeReactProvider>
        <RouterProvider router={router}>
          <div className="App">
            <Login />
          </div>
        </RouterProvider>
      </PrimeReactProvider>
      </NotificationProvider>
    </QueryClientProvider>
  );
}

export default App;
